/* eslint-disable no-unused-vars */
import MixpanelTracker from "./MixpanelTracker";
import AvataarTracker from "./AvataarTracker";
import GATracker from "./GATracker";

const mod = () => {
  const initializeAnalytics = (isRemoteAnalytics, experienceId, mode) => {
    AvataarTracker.initializeAnalytics(isRemoteAnalytics, experienceId, mode);
    GATracker.initializeAnalytics(isRemoteAnalytics);
    MixpanelTracker.initializeAnalytics(isRemoteAnalytics, experienceId, mode)
  };

  const sendAnalyticsEvent = (
    eventType,
    data = {},
    options = {},
    other = {}
  ) => {
    AvataarTracker.sendAnalyticsEvent(eventType, data, options, other);
    GATracker.sendAnalyticsEvent(eventType, data, options, other);
    MixpanelTracker.sendAnalyticsEvent(eventType, data, options, other)
  };

  const getLastInteractionTime = () => {
    return AvataarTracker.getLastInteraction;
  };

  return {
    sendAnalyticsEvent,
    initializeAnalytics,
    getLastInteractionTime,
  };
};

const CommonTracker = mod();
export default CommonTracker;
